<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		data() {
			return {

			}
		},
		created() {
			this.getToken()
			this.getOrdertoken()
		},
		methods: {
			...mapMutations('account', ['setUserToken', 'setOrderToken']),
			getToken() {
				this.$post(
					this.$connectHttpSweet + '/TeamAll/GetToken?organizationId=2', {}
				).then(res => {
					this.setUserToken(res.result)
				})
			},
			getOrdertoken() {
				this.$post(
					this.$connectHttpSweet + '/TeamAll/GetToken?organizationId=1', {}
				).then(res => {
					this.setOrderToken(res.result)
				})
			}
		}
	}
</script>

<style>
	h2,
	h3,
	p {
		padding: 0;
		margin: 0;
	}

	img {
		vertical-align: bottom;
	}

	html,
	body,
	#app {
		width: 100%;
		height: 100%;
		padding: 0;
		margin: 0;
	}

	#app {
		font-family: 'Microsoft YaHei', Helvetica, Arial, sans-serif;
		/* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		/* padding-bottom: calc(120px + constant(safe-area-inset-bottom));
		padding-bottom: calc(120px + env(safe-area-inset-bottom)); */
	}

	.detailBottom {
		position: fixed;
		bottom: 0;
		left: 0;
		height: 100px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #fff;
		width: 100%;
		border-top: 1px solid #ccc;
		font-size: 24px;
		z-index: 4;
	}

	.detailBottom span,
	.detailBottom a {
		flex: 1;
		height: 100px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #333;
	}

	.detailBottom span {
		color: #fff;
		background-color: #ff6d00;
	}

	.grays {
		background-color: #ccc !important;
	}

	.wrapper {
		width: 100%;
		position: fixed;
		bottom: 0;
		left: 0;
		background-color: #fff;
	}

	.wrapper h2 {
		font-size: 36px;
		text-align: center;
		padding: 20px 0;
		font-weight: normal;
	}

	.wrapper span {
		display: flex;
		flex-direction: column;
		width: 100%;
		padding: 0 60px 60px 60px;
		box-sizing: border-box;
	}

	.wrapper label {
		font-size: 28px;
		color: #333;
		height: 42px;
		line-height: 42px;
		background: #f8f8f8;
		font-weight: 500;
		margin-top: 60px;
		margin-bottom: 20px;
	}

	.wrapper p {
		font-size: 24px;
		color: #666;
		line-height: 48px;
	}
</style>